import { CSSObject, styled } from 'libs/ui/styled';

export const FooterStyled = styled('footer')({
  display: 'flex',
  justifyContent: 'end',
  marginTop: 32,
  alignItems: 'center',
  gap: 40,
});

export const FieldsStyled = styled('div')(({ theme }) => ({
  marginTop: 32,
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  [theme.breakpoints.down('mobile')]: {
    gap: 16,
  } as CSSObject,
}));
